export default "__VITE_ASSET__d18c7a32__"